<template>
     <v-alert
      @input="onClose"
      dismissible
      type="success"
      :value="true"
    >
      {{text}}
    </v-alert>
</template>
<script>
export default {
    props: ['text'],
    methods: {
        onClose() {
            this.$emit('dismissed')
        },
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Shared/AlertSuccess.vue